export const sentry = {
  dsn: process.env.REACT_APP_SENTRY_DSN
}

export const api = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:1337/api'
}

export const uploadsBaseUrl = process.env.REACT_APP_UPLOADS_BASE_URL ||
  'http://localhost:1337'

const config = { sentry, api, uploadsBaseUrl }

export default config
